import { Injectable } from '@angular/core';
import { CustomProduct } from '@product/const';
import { RoutingService } from '@spartacus/core';
import { filter, map } from 'rxjs';
import { CatalogAnalyticsService } from '../catalog-analytics.service';
import { ProductListCartAnalyticsService } from './product-list-cart-analytics.service';

export interface ProductCartItemAnalyticsOptions {
  listName?: string;
  productIndex?: number;
}

@Injectable({ providedIn: 'root' })
export class ProductCartItemAnalyticsService {
  private semanticRoute: string | undefined;

  constructor(
    private productListCartAnalyticsService: ProductListCartAnalyticsService,
    private catalogAnalyticsService: CatalogAnalyticsService,
    private routingService: RoutingService,
  ) {
    this.routingService
      .getRouterState()
      .pipe(
        filter((routerState) => Boolean(routerState.state.semanticRoute)),
        map((routerState) => routerState.state.semanticRoute),
      )
      .subscribe((semanticRoute) => {
        this.semanticRoute = semanticRoute;
      });
  }

  saveForProduct(product: CustomProduct, options?: ProductCartItemAnalyticsOptions): void {
    this.productListCartAnalyticsService.saveAnalyticDataForEntry(
      { product },
      {
        listName: this.resolveListName(product, options?.listName),
        productIndex: this.resolveProductIndex(options?.productIndex),
      },
    );
  }

  private resolveListName(product: CustomProduct, listName?: string): string | undefined {
    return listName || this.catalogAnalyticsService.productInListClicked?.listName || this.getDefaultListName(product);
  }

  private resolveProductIndex(productIndex?: number): number | undefined {
    if (productIndex !== undefined && productIndex !== null) {
      return productIndex;
    }

    return this.catalogAnalyticsService.productInListClicked?.index;
  }

  private getDefaultListName(product: CustomProduct): string | undefined {
    if (!this.semanticRoute || !product?.code) {
      return undefined;
    }

    if (this.semanticRoute.includes('product')) {
      return `Карточка-товара_${product.code}`;
    }

    return `${this.semanticRoute}_${product.code}`;
  }
}
